<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>我的消费列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入订单号查询" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker v-model="queryInfo.time" @change="timechange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </el-col>

        <el-col :span="8">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="订单编号" prop="order_id" width="150px"></el-table-column>
        <el-table-column label="商品信息" type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark" style="width: 60%">
              <el-table-column label="名称" prop="goodinfo.title"> </el-table-column>
              <el-table-column label="规格" prop="goodinfo.preNum"> </el-table-column>
              <el-table-column label="数量" prop="goodinfo.buyNum"> </el-table-column>
              <el-table-column label="活动" prop="activityContent"> </el-table-column>
              <el-table-column label="满赠件数" prop="sendNumber"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <!-- <el-table-column label="经销商" prop="agencyName" width="130px"></el-table-column> -->
        <el-table-column label="金额" prop="money" align="center" width="60px"> </el-table-column>
        <!-- 充值余额，授信余额，冻结余额 -->
        <el-table-column label="充值账户" prop="payWithMoney" align="center" width="80px"> </el-table-column>
        <el-table-column label="授信账户" prop="payWithCredit" align="center" width="80px"> </el-table-column>
        <el-table-column label="冻结账户" prop="payWithDongjie" align="center" width="80px"> </el-table-column>
        <el-table-column label="收支状态" prop="typeTxt" align="center" width="90px"> </el-table-column>

        <el-table-column label="审核状态" width="140px">
          <!-- 自定义表头 -->
          <!-- <template slot="header" slot-scope="scope">
            <el-select v-model="queryInfo.status" placeholder="请选择" @change="filterSelect">
              <el-option v-for="item in statusOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
            </el-select>
          </template> -->
          <!-- 审核状态0未审核，1审核通过2拒绝 -->
          <template slot-scope="scope" v-if="scope.row.type == '2'">
            <el-tag type="warning" v-if="scope.row.status == '0'">待审核</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.status == '1'">审核通过</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.status == '2'">拒绝</el-tag>
            <!-- <el-tag type="danger" v-else>未付款</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="create_at" width="130px">
          <template slot-scope="scope">
            {{ scope.row.create_at | dateFormat }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="250px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editOrder(scope.row.order_id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteOrder(scope.row.order_id)">删除</el-button>
            <a class="aaaa" target="_blank" :href="scope.row.export" v-if="scope.row.order_status == 2">
              <el-button size="mini" @click="exportOrder()" type="info">导出出货单</el-button>
            </a>
            </template>
        </el-table-column> -->
      </el-table>

      <!-- <el-row>
        <el-button type="primary" plain @click="sureOrder">批量订单确认</el-button>
        <el-button type="info" plain @click="sendOrder">批量订单发货</el-button>
        <el-button type="success" plain @click="completeOrder">批量完成订单</el-button>
        <el-button type="danger" plain @click="cancelOrder">批量取消订单</el-button>
      </el-row> -->
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      exportUrl: 'javascript:return false;',
      queryInfo: {
        query: '',
        status: -1,
        type: 0,
        phone: 0,
        pagenum: 1,
        pagesize: 10,
        time: []
      },
      statusValue: '全部',
      // 审核状态0未审核，1审核通过2拒绝
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '未审核', id: 0 },
        { value: '审核通过', id: 1 },
        { value: '拒绝', id: 2 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],
      total: 0,
      orderlist: [],
      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created () {
    this.queryInfo.phone = window.sessionStorage.getItem('phone')
    this.getOrderList()

  },

  methods: {

    timechange (e) {
      console.log(this.queryInfo.time)
      // console.log(e);
      this.filterSelect();
    },

    searchOrder () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },


    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.sqmilk.com/jxsMyComsumeList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = "javascript:return false;"
      }
    },

    async getOrderList () {
      console.log(this.queryInfo)
      const { data: res } = await this.$http.get('admin/users/getMyjxsComsumeList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
